import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ClassCenterReadSlice = createSlice({
  name: "ClassCenterReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ClassCenterRead: (state) => {
      state.isLoading = true;
    },
    successClassCenterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureClassCenterRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearClassCenterRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  ClassCenterRead,
  successClassCenterRead,
  failureClassCenterRead,
  clearClassCenterRead,
} = ClassCenterReadSlice.actions;

export default ClassCenterReadSlice.reducer;
